/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Out_Of_SyncInputs */



/**
* | output |
* | --- |
* | "Out of sync with vekn.net" |
*
* @param {Vekn_Out_Of_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_out_of_sync = /** @type {((inputs?: Vekn_Out_Of_SyncInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Out_Of_SyncInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Désynchronisé de vekn.net")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desincronizado de vekn.net")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Dessincronizado de vekn.net")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non sincronizzato con vekn.net")
	return /** @type {LocalizedString} */ ("Out of sync with vekn.net")
});